export default class ActivityMeta {
    public totalItems: number = 0;
}